import { FontName } from '.';

export default {
  result: {
    titleText: {
      color: '#b68351',
      size: 45,
      align: 'left' as const,
      verticalAlign: 'center' as const,
      font: 'Body' as FontName,
      width: 133,
      height: 76,
    },
    scoreFrame: {
      width: 285,
      height: 76,
      image: 'assets/ui/shared/lossless/panel_overlay.png',
      scaleMethod: '9slice' as const,
      sourceSlices: {
        horizontal: { left: 20, right: 20 },
        vertical: { top: 20, bottom: 20 },
      },
    },

    points: {
      color: '#876969',
      size: 45,
      align: 'right' as const,
      verticalAlign: 'center' as const,
      font: 'Body' as FontName,
      width: 270,
      height: 76,
    },

    separator: {
      height: 5,
      backgroundColor: '#e7b77e',
    },

    arrowDown: {
      width: 22,
      height: 14,
      image: 'assets/ui/shared/icons/arrow_down.png',
      y: -9,
      centerOnOrigin: true,
    },

    arrowUp: {
      width: 22,
      height: 14,
      image: 'assets/ui/shared/icons/arrow_down.png',
      centerOnOrigin: true,
      r: Math.PI,
    },

    arrowLabel: {
      color: '#b68351',
      size: 20,
      align: 'center' as const,
      verticalAlign: 'center' as const,
      font: 'Body' as FontName,
      width: 85,
      height: 24,
      x: 11,
      y: -20,
      centerOnOrigin: true,
    },

    arrowCoinIcon: {
      width: 30,
      height: 30,
      image: 'assets/ui/hud/icons/hud_coin.png',
      x: 11,
      y: -50,
      centerOnOrigin: true,
    },

    coinsFrame: {
      width: 236,
      height: 76,
      image: 'assets/ui/shared/lossless/inset_panel.png',
      scaleMethod: '9slice' as const,
      sourceSlices: {
        horizontal: { left: 25, right: 25 },
        vertical: { top: 25, bottom: 25 },
      },
    },

    coinIcon: {
      width: 55,
      height: 55,
      image: 'assets/ui/hud/icons/hud_coin.png',
      x: 35,
      centerOnOrigin: true,
    },

    valueLabel: {
      color: '#f2f5ef',
      size: 45,
      align: 'right' as const,
      verticalAlign: 'center' as const,
      font: 'Body' as FontName,
      width: 216,
      height: 76,
    },

    gemIcon: {
      width: 60,
      height: 55,
      image: 'assets/ui/hud/icons/hud_gem.png',
      x: 40,
      centerOnOrigin: true,
    },
  },
};
